import React from 'react';
import './ContactHeroSection.css';

function ContactHeroSection() {
  return (
    <section className="contact-hero">
      <div className="contact-hero-content">
        {/* <h1>Contact Us</h1>
        <p>We’re here to help. Reach out to us for any inquiries or assistance.</p> */}
      </div>
    </section>
  );
}

export default ContactHeroSection;